<template>
  <div v-if="model">
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="450"
      persistent
      scrollable
    >
      <v-card>
        <v-toolbar
          class="pl-1"
          extension-height="40"
          flat
          height="80"
          max-height="120"
        >
          <v-avatar :color="$t('Settings.VoipDomain.Dialog.VoipDomain.Toolbar.Color')">
            <v-icon dark>
              {{ $t('Settings.VoipDomain.Dialog.VoipDomain.Toolbar.Icon') }}
            </v-icon>
          </v-avatar>

          <v-toolbar-title class="pl-3">
            <div class="body-3">
              {{ isEditMode ? $t('Settings.VoipDomain.Dialog.VoipDomain.Toolbar.Edit.Title') : $t('Settings.VoipDomain.Dialog.VoipDomain.Toolbar.Add.Title') }}
            </div>

            <div class="text-caption">
              {{ isEditMode ? $t('Settings.VoipDomain.Dialog.VoipDomain.Toolbar.Edit.Subtitle') : $t('Settings.VoipDomain.Dialog.VoipDomain.Toolbar.Add.Subtitle') }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            icon
            @click="onCancelButtonClick"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-3">
          <v-form
            ref="dataForm"
            v-model="dataFormValid"
            @submit.prevent
          >
            <v-container
              class="pa-0"
              fluid
            >
              <v-row dense>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="model.DomainId"
                    :disabled="isEditMode"
                    :items="domains"
                    :label="$t('Settings.VoipDomain.Dialog.VoipDomain.Filed.DomainId.Label')"
                    :rules="validationRules.dataForm.DomainId"
                    clearable
                    item-text="Domain"
                    item-value="Id"
                  />
                </v-col>

                <v-col cols="6">
                  <v-tooltip
                    bottom
                    open-delay="500"
                  >
                    <template #activator="{on}">
                      <v-text-field
                        v-model="model.VoipId"
                        v-mask="'######'"
                        :label="$t('Settings.VoipDomain.Dialog.VoipDomain.Filed.VoipId.Label')"
                        :rules="validationRules.dataForm.VoipId"
                        clearable
                        required
                        v-on="on"
                      />
                    </template>

                    <img
                      :alt="$t('Settings.VoipDomain.Dialog.VoipDomain.Filed.VoipId.Label')"
                      class="mt-2"
                      src="data:image/png;base64,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"
                    >
                  </v-tooltip>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="model.Phone"
                    v-mask="'##########'"
                    :label="$t('Settings.VoipDomain.Dialog.VoipDomain.Filed.Phone.Label')"
                    :rules="validationRules.dataForm.Phone"
                    clearable
                    required
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="model.Description"
                    :label="$t('Settings.VoipDomain.Dialog.VoipDomain.Filed.Description.Label')"
                    :rules="validationRules.dataForm.Description"
                    clearable
                    required
                  />
                </v-col>

                <v-col
                  cols="12"
                >
                  <div class="d-inline-block">
                    <p class="grey--text text-caption ma-0">
                      {{ $t('Settings.VoipDomain.Dialog.VoipDomain.Filed.VoipActive.Label') }}
                    </p>
                    <v-switch
                      v-model="model.VoipActive"
                      :label="model.VoipActive ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      inset
                    />
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />

          <v-btn
            class="light-blue--text text--darken-1"
            outlined
            @click="onCancelButtonClick"
          >
            {{ $t('Common.Button.Cancel').toLocaleUpperCase($i18n.locale) }}
          </v-btn>

          <v-btn
            :disabled="isSaving"
            :loading="isSaving"
            class="green white--text elevation-0"
            @click="onSaveButtonClick"
          >
            {{ $t('Common.Button.Save').toLocaleUpperCase($i18n.locale) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppData from '@/mixins/appdata'
import Auth from '@/mixins/auth'
import {clone} from '@/lib/helper/helper'

export default {
  name      : 'VoipDomainEditDialog',
  components: {},
  mixins    : [AppData, Auth],
  props     : {
    visible: {
      type   : Boolean,
      default: false
    },
    voipDomain: {
      type   : Object,
      default: undefined
    }
  },
  data() {
    return {
      dataFormValid  : false,
      isSaving       : false,
      model          : null,
      validationRules: {
        dataForm: {
          DomainId: [
            (v) => !!v || this.$t('Settings.VoipDomain.Dialog.VoipDomain.Filed.DomainId.Error.Required')
          ],
          VoipId: [
            (v) => !!v || this.$t('Settings.VoipDomain.Dialog.VoipDomain.Filed.VoipId.Error.Required')
          ],
          Phone: [
            (v) => !!v || this.$t('Settings.VoipDomain.Dialog.VoipDomain.Filed.Phone.Error.Required'),
            (v) => !!v && v.length === 10 || this.$t('Settings.VoipDomain.Dialog.VoipDomain.Filed.Phone.Error.Valid')
          ],
          Description: [
            (v) => !!v || this.$t('Settings.VoipDomain.Dialog.VoipDomain.Filed.Description.Error.Required')
          ]
        }
      }
    }
  },
  computed: {
    domains() {
      return this.$DataStore?.appDomains || []
    },

    isEditMode() {
      return !!this.model?.Id
    },

    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        if (this.$refs.dataForm) this.$refs.dataForm.resetValidation()

        if (this.voipDomain) {
          this.model = {
            Id         : this.voipDomain?.Id || null,
            DomainId   : this.voipDomain?.DomainId || null,
            VoipId     : this.voipDomain?.VoipId || '',
            Phone      : this.voipDomain?.Phone || '',
            Description: this.voipDomain?.Description || '',
            VoipActive : this.voipDomain?.Domain?.VoipActive ?? false
          }
        } else {
          this.model = {
            Id         : null,
            DomainId   : null,
            VoipId     : '',
            Phone      : '',
            Description: '',
            VoipActive : true
          }
        }

        this.$bus.$on(window.SocketCommand.Settings.VoipDomains.Save, this.onUserSaveResult)
      } else {
        this.$bus.$off(window.SocketCommand.Settings.VoipDomains.Save, this.onUserSaveResult)
      }

      this.isSaving = false
    }
  },
  created() {
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  methods: {
    onSaveButtonClick() {
      this.$refs.dataForm.validate()

      if (this.dataFormValid) {
        this.isSaving = true
        const payload = clone(this.model)
        window.callAS(window.SocketCommand.Settings.VoipDomains.Save, payload)
      }
    },

    onUserSaveResult(data, payload) {
      if (data?.status === 'success') {
        this.$emit('save-success', payload)
        this.onCancelButtonClick()
      }

      this.isSaving = false
    },

    onCancelButtonClick() {
      if (this.$refs.dataForm) this.$refs.dataForm.resetValidation()
      this.isVisible = false
      this.isSaving = false
      this.model = null
    }
  }
}
</script>
